module.exports = __webpack_public_path__ + "static/media/background1.51f990c3.jpg";